const JOB_MANAGER_PATH: string = '/job-manager';
const CREATE_NEW_JOB_MANAGER_PATH: string = `${JOB_MANAGER_PATH}/new`;

export const JOB_MANAGER_PATHS = {
    LANDING_PAGE: JOB_MANAGER_PATH,
    CREATE_NEW_JOB: CREATE_NEW_JOB_MANAGER_PATH,
    CREATE_UPLOAD_DICTIONARY_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/upload-data-dictionary`,

    CREATE_UPLOAD_FILE_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/upload-file`,
    CREATE_DOWNLOAD_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/download-job`,
    CREATE_DBSCHEMA_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/upload-db-schema`,
    CREATE_TRUNCATE_CHAIN_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/truncate-chain-job`,
    CREATE_EXECUTE_SMART_CONTRACT_JOB: `${CREATE_NEW_JOB_MANAGER_PATH}/execute-smart-contract-job`,
    RESET_SDZ_DATA: `${CREATE_NEW_JOB_MANAGER_PATH}/reset-sdz-data`,
    WIPE_SDZ_DATA: `${CREATE_NEW_JOB_MANAGER_PATH}/wipe-sdz-data`,
    DROP_CHAIN: `${CREATE_NEW_JOB_MANAGER_PATH}/drop-chain`,
    EXPORT_DATA: `${CREATE_NEW_JOB_MANAGER_PATH}/export-data`,
};
